import type { CustomField, FieldDataType } from '@feathr/blackbox';

import defaultPersonFields from '@feathr/blackbox/fixtures/defaultPersonFields.json';

export const DEFAULT_PERSON_FIELD_IDS: readonly string[] = ['name', 'email'];

export interface IPersonFieldOption {
  id: string;
  name: string;
  type: FieldDataType;
}

export type TEmailInteractionType = 'delivery' | 'open' | 'click';

export const DEFAULT_EMAIL_INTERACTION_TYPES: readonly TEmailInteractionType[] = [
  'delivery',
  'open',
];

export interface IInteractionTypeOption {
  id: TEmailInteractionType;
  label: string;
}

export interface IEmailActivityExportPayload {
  name: string;
  email: string;
  interaction_types: TEmailInteractionType[];
  start_date?: string;
  end_date?: string;
}

export function getInteractionTypeOptions(t: (key: string) => string): IInteractionTypeOption[] {
  return [
    { id: 'delivery', label: t('Delivery') },
    { id: 'open', label: t('Open') },
    { id: 'click', label: t('Click') },
  ];
}

/**
 * `{{ group-name }}` → groupName (falls back to `group` when empty).
 * `{{ date }}` → today formatted as `YYYY-MM-DD` (UTC).
 */
export function resolveExportNameTemplate(groupName: string, today: Date = new Date()): string {
  const safeName = groupName.trim().length > 0 ? groupName : 'group';
  const datePart = today.toISOString().split('T')[0];
  return `${safeName}_${datePart}`;
}

// Custom fields get the `custom.<f_key>` id prefix per the export contract.
export function getPersonFieldOptions(customFields: CustomField[]): IPersonFieldOption[] {
  const defaults: IPersonFieldOption[] = defaultPersonFields.map((f) => ({
    id: f.id,
    name: f.name,
    type: f.type as FieldDataType,
  }));

  const customOptions: IPersonFieldOption[] = customFields.map((field) => ({
    id: `custom.${field.get('f_key')}`,
    name: field.get('u_key'),
    type: field.get('data_type'),
  }));

  return [...defaults, ...customOptions];
}
